import React from 'react';
import {Button, Row, Col, OverlayTrigger, Popover} from 'react-bootstrap';
import Component from '../../components/AscComponent';
import CommonTable from '../../containers/Elements/Table/CommonTable';
import UserDeleteModal from './UserDeleteModal';
import UserInsertModal from './UserInsertModal';
import UserUpdateModal from './UserUpdateModal';
import UserReadModal from './UserReadModal';
import UserMfaOffModal from './UserMfaOffModal';
import { CSVLink } from 'react-csv';
// 外線番号ユーティリティは純粋関数集約ファイル AscUtils へ移動
import { evaluateExternalNumbers, detectInvalidExternalNumbers, extractExternalValues } from '../../components/AscUtils';
import * as GlobalConst from '../../components/AscConstants';

// 【#590】所有デバイス列にそのまま出す件数（超えた分は同じ行の「他 N 件」にまとめ、行の高さを 1 行に揃える）
const USER_DEVICE_VISIBLE_COUNT = 1;

export default class User extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            pageSize: 20,
            pages: null,
            loading: false,
            filtered: [],
            sorted: [{id: 'id', desc: true}],

            selectedData: [],

            // modal item
            show: false,
            modalType: null,
            password_change: false,
            // 多要素認証（#443）の無効化確認モーダル
            showMfaOffModal: false,
            // Issue #443: 無効化の対象。null は親ユーザー、{hm16_id, sub_user_id} はサブユーザー
            mfaOffTarget: null,
            // Issue #443: 無効化はサーバ側でパスワード再認証が必須（第2要素を外す操作のため）
            mfaOffPassword: '',
            mfaOffExecuting: false
        };

        this.onMultiSelectChange_External = this.onMultiSelectChange_External.bind(this);
        this.csvRef = React.createRef();
    }
    /**
     * 一覧表作成
     */
    getColumnsData() {
        return [
            {
                Header: this.props.langText.Body.UserId,
                accessor: 'user_id',
                width: this.props.boardWidth.smedium,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "user_id")}
                    />

            }, {
                Header: this.props.langText.Body.Name,
                // 【#608】react-table は accessor の無い列に検索欄を出さない（canFilter が false になる）。
                // 姓名をつなげた値を accessor にし、検索欄のキーとして id を付ける。
                // 絞り込みはサーバー側で姓名をつなげた値に部分一致させる（表示は Cell のまま）
                id: 'user_name',
                accessor: row => `${row.family_name || ''}${row.first_name || ''}`,
                // 名前での並び替えは対象外（サーバーに user_name 列は無い）
                disableSortBy: true,
                width: this.props.boardWidth.Name,
                Cell: data =>{
                    let family_name = data.row.original.family_name || '';
                    let first_name = data.row.original.first_name || '';
                    return family_name+'　'+first_name;
                },
                // 待ち時間（デバウンス）は他の列と同じ onFilterChange に任せる
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "user_name")}
                    />
            }, {
                Header: this.props.langText.Body.MailAddress,
                accessor: 'mail_address',
                width: this.props.boardWidth.xlarge,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "mail_address")}
                    />
            }, {
                Header: this.props.langText.Body.Telno,
                accessor: 'tel_number',
                width: this.props.boardWidth.CallNumber,
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "tel_number")}
                    />
            }, {
                Header: this.props.langText.Body.Permission,
                accessor: 'hm73_permission.name',
                width: this.props.boardWidth.smedium,
                disableFilters: true
            }, {
                // Issue #443: 二要素認証（メールOTP）の状態
                Header: this.props.langText.Body.MfaStatus,
                width: this.props.boardWidth.xsmall,
                Cell: data => {
                    let options = data.row.original.options;
                    return (options && options.mfa && options.mfa.email_enabled)
                        ? this.props.langText.Body.MfaStatusOn
                        : this.props.langText.Body.MfaStatusOff;
                },
                disableFilters: true
            }, {
                Header: this.props.langText.Body.OwnDevice,
                accessor: 'hm20_devices.serial_number',
                width: this.props.boardWidth.smedium,
                filterable: true,
                // 【#590】デバイスを多く持つユーザーで行が縦に伸びないよう、先頭の数件だけを出し、
                // 残りは「他 N 件」にまとめてポップオーバーで全件を見せる
                Cell: data => {
                    const devices = data.row.original.hm20_devices || [];
                    const shown = devices.slice(0, USER_DEVICE_VISIBLE_COUNT);
                    const restCount = devices.length - shown.length;
                    return (
                        <div className="user-device-cell">
                            {shown.map(row => <span key={row.id} className="user-device-serial">{row.serial_number}</span>)}
                            {restCount > 0 && (
                                <OverlayTrigger
                                    // タッチ端末ではホバーが無いため、タップでも開閉できるようにする
                                    trigger={["hover", "focus", "click"]}
                                    rootClose
                                    placement="left"
                                    overlay={
                                        <Popover id={`user-devices-${data.row.original.id}`}>
                                            <Popover.Header as="div">
                                                {this.props.langText.Body.OwnDevice}（{devices.length}）
                                            </Popover.Header>
                                            <Popover.Body className="user-device-popover-body">
                                                {devices.map(row => <div key={row.id}>{row.serial_number}</div>)}
                                            </Popover.Body>
                                        </Popover>
                                    }
                                >
                                    <button
                                        type="button"
                                        className="user-device-more"
                                        onClick={e => e.stopPropagation()}
                                        aria-label={`${this.props.langText.Body.OwnDevice} ${devices.length}`}
                                    >
                                        {this.props.langText.Body.OtherCount.replace("{count}", restCount)}
                                    </button>
                                </OverlayTrigger>
                            )}
                        </div>
                    );
                },
                Filter: () =>
                    <input
                        className="filter-input"
                        onChange={e => this.onFilterChange(e.target.value, "hm20_devices.serial_number")}
                    />
            }
        ]
    }

    /**
     * 各ボタンから新しいmodal表示する際に使用する関数
     */
    modalShow = (modalType) => async event => {
        event.preventDefault();
        try{
            let user_id = "";
            let password = "";
            if (modalType === "insert") {
                let user_id_con = await this.ascAxios('post', `${this.reactContainerPath}/getUserId`);
                user_id = user_id_con.data.value;
                do {
                    password = Math.random().toString(36).substr(2, 8);
                } while (!this.validatePassword(password))
            }
            let deviceList, permissionList, externalList = [];
            let {selectedData} = this.state;

            if((modalType === "update" || modalType === "delete" || modalType === "read")&& selectedData.length === 0){
                //編集・削除の場合一つ以上の項目選択必須
                return this.showErrorObjectMessage('User_ModalSelectError')
            } else if(modalType === "update" && selectedData.length > 1){
                //編集場合一つの項目だけ選択可能
                return this.showErrorObjectMessage('User_UpdateModalSelectError')
            }
            let updateData = (modalType==="update" || modalType === "read") && selectedData.slice().pop();

            if(modalType === "insert" || modalType === "update" || modalType === "read"){
                // Issue #451: system レベルの管理者が他社ユーザーを編集する場合、
                // 操作者の会社IDを渡すと対象ユーザーの現在の権限が候補に含まれず
                // プルダウンが空欄になる（選び直すとサーバ側の検証で 400 になる）。
                // 対象ユーザーの会社IDを渡す。新規登録時は対象が未確定のため操作者の会社IDを使う。
                // デバイス一覧も同じ理由で対象ユーザーの会社IDで取得する。
                const targetCompanyId = (updateData && updateData.hm12_id)
                    ? updateData.hm12_id
                    : this.props.userInfo.company_id;
                deviceList = await this.getDeviceList(updateData && updateData.id, targetCompanyId);
                permissionList = await this.getPermissionList(targetCompanyId);
            }
            if(modalType === "update" || modalType === "read"){
                externalList = await this.getExternalNumberByUser(updateData && updateData.id)
            }

            let setData = {
                hm15_id:updateData && updateData.id
                    ? updateData.id
                    : 0,
                hm12_id:updateData && updateData.hm12_id
                    ? updateData.hm12_id
                    : this.props.userInfo.company_id,
                user_id: updateData && updateData.user_id
                    ? updateData.user_id
                    : user_id,
                family_name: updateData && updateData.family_name
                    ? updateData.family_name
                    : '',
                first_name: updateData && updateData.first_name
                    ? updateData.first_name
                    : '',
                mail_address: updateData && updateData.mail_address
                    ? updateData.mail_address
                    : '',
                tel_number: updateData && updateData.tel_number
                    ? updateData.tel_number
                    : '',
                password: modalType === 'update'
                    ? ''
                    : password,
                hm73_id: updateData && updateData.hm73_id
                    ? updateData.hm73_id
                    : 0,
                hm73_level: updateData && updateData.hm73_permission && updateData.hm73_permission.data
                && updateData.hm73_permission.data.Permission && updateData.hm73_permission.data.Permission.level
                    ? updateData.hm73_permission.data.Permission.level
                    : "",
                hm73_name: updateData && updateData.hm73_permission && updateData.hm73_permission.name
                    ? updateData.hm73_permission.name
                    : "",
                hm20_id: updateData && updateData.hm20_devices
                    ?  updateData.hm20_devices.map(row=> {return row.id})
                    : [],
                hm20_id_before: updateData && updateData.hm20_devices
                    ?  updateData.hm20_devices.map(row=> {return row.id})
                    : [],
                deviceList: deviceList,
                permissionList: permissionList,
                external_number: externalList,
                external_number_val: externalList.map(row=>{
                    return row.value
                }),
                type: updateData && updateData.type ? updateData.type : "Business",
                voices_expire: updateData && updateData.voices_expire
                    ? updateData.voices_expire
                    : this.props.langText.Value.voices_expire_default.Business,
                option_voices_expire: updateData && updateData.voices_expire
                    ? Math.floor(Number(updateData.voices_expire - this.props.langText.Value.voices_expire_default.Business) / 365)
                    : 0,
                // 新規作成時は会社オプション(company_options)をデフォルトのチェック状態として反映しない。
                // 機能の付与はユーザーが明示的にチェックした場合のみとする (Issue #334)。
                // OPTIONS に新しいキーを追加する際も、ここに company_options 由来の既定値を入れないこと。
                // ※ チェックボックスの表示可否は SelectOptions 側の COMPANY_GATED_OPTIONS で別途制御している。
                options: updateData && updateData.options
                    ? updateData.options
                    : {},
                // 【#541 レビュー指摘】モーダルの初期値は一覧取得時のキャッシュ行であり、
                // 開いている間に他の管理者が上限を変更していることがある。開いた時点の値を
                // 控えておき、利用者が触っていなければ保存時に sub_user_limit キーを送らない
                // （サーバーは「キー無し＝変更なし」でマージするため、古い値での巻き戻りを防げる）。
                sub_user_limit_loaded: (updateData && updateData.options
                    && updateData.options.sub_user_limit !== undefined)
                    ? updateData.options.sub_user_limit
                    : null,
                // Issue #443: 二要素認証の現在値（OFFにするボタンの表示判定に使用）
                mfa_enabled: !!(updateData && updateData.options && updateData.options.mfa
                    && updateData.options.mfa.email_enabled),
                // Issue #443: サブユーザーの二要素認証。サブユーザーがメールを受け取れなくなった際、
                // 管理者がここから OFF にできるようにする（サーバは hm16_id の有無で対象を分岐する）
                mfa_sub_users: (updateData && Array.isArray(updateData.hm16_sub_users))
                    ? updateData.hm16_sub_users.map(row => ({
                        hm16_id: row.id,
                        sub_user_id: row.sub_user_id,
                        mfa_enabled: !!(row.options && row.options.mfa && row.options.mfa.email_enabled)
                    }))
                    : [],
                modalType: modalType,
                password_change: false,
                show: true
            };

            if(modalType === "delete"){
                setData.hm15_id = selectedData.map(row=>row.id);
                setData.user_id = selectedData.map(row=>row.user_id);
                setData.hm20_id_check = selectedData.map(row=>{
                    let obj = {};
                    obj[row.id] = row.hm20_devices.map(device=> device.id);
                    return obj;
                })
                setData.isLoginedUser = setData.user_id.find(row=> row === this.props.userInfo.user_id)
                selectedData.map(row=>row.name = row.family_name+"　"+row.first_name)
            }

            // 外線番号のバリデーション再評価（ユーティリティ使用）
            if (Array.isArray(setData.external_number)) {
                const { values, invalids } = evaluateExternalNumbers(setData.external_number);
                setData.external_number_val = values;
                setData.external_number_invalids = invalids;
            } else {
                setData.external_number_val = [];
                setData.external_number_invalids = [];
            }
            this.setState(setData);
        }catch(err){
            console.error(err)
            this.showErrorObjectMessage(err);
        }
    };

    onMultiSelectChange_External (event) {
        if (Array.isArray(event)) {
            const values = extractExternalValues(event);
            const invalids = detectInvalidExternalNumbers(event);
            this.setState({
                external_number: event,
                external_number_val: values,
                external_number_invalids: invalids
            });
        } else {
            this.setState({
                external_number: [],
                external_number_val: [],
                external_number_invalids: []
            });
        }
    }

    onSelectChange (event, param) {
        let value = event && event.value ? event && event.value : "";
        let voices_expire_default_info = this.props.langText.Value.voices_expire_default;
        switch (param) {
            case "type":
                this.setState({
                    voices_expire: voices_expire_default_info[value]
                });
                break;
            default:
                break;
        }
        this.setState({[param]: value});
    }

    onClickHandle = modalType => async () => {
        let {
            user_id,
            family_name,
            first_name,
            mail_address,
            tel_number,
            external_number_val,
            password,
            hm73_id,
            hm12_id,
            hm15_id,
            hm20_id,
            hm20_id_before,
            hm20_id_check,
            isLoginedUser,
            type,
            options,
            voices_expire,
            option_voices_expire,
            sub_user_limit_loaded
        } = this.state;

        voices_expire = this.props.langText.Value.voices_expire_default[type] + (option_voices_expire * 365);
        // 【#541 レビュー指摘】上限を触っていない保存で、モーダルを開いた時点の古い値を
        // 送り返さない。値が変わっていないときはキーごと落とす（Lost Update の防止）。
        const updateOptions = this.buildOptionsForUpdate(options, sub_user_limit_loaded);
        try {
            switch (modalType) {
                case 'insert':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/insert`, {
                        user_id,
                        password,
                        family_name,
                        first_name,
                        mail_address,
                        tel_number,
                        external_number_val,
                        hm73_id,
                        hm20_id,
                        hm12_id,
                        type,
                        options,
                        voices_expire
                    })
                    let headers = [
                        { label: this.props.langText.Body.UserId, key: "user_id" },
                        { label: this.props.langText.Body.Password, key: "password" },
                    ];
                    let data = [{ user_id, password}];
                    let DownloadData =
                        <CSVLink
                            headers = {headers}
                            data = {data}
                            className = "hidden"
                            filename = {user_id+this.props.langText.Body.UserInfo+".csv"}
                            ref = {this.csvRef}
                        />
                    this.setState({DownloadData});
                    this.csvRef.current.link.click();
                    alert(this.props.langText.Message.DataInsertSuccess);
                    this.reactTableRefresh(true);
                    break;
                case 'update':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/update`, {
                        user_id,
                        hm15_id,
                        password,
                        family_name,
                        first_name,
                        mail_address,
                        tel_number,
                        external_number_val,
                        hm73_id,
                        hm20_id,
                        hm20_id_before,
                        options: updateOptions,
                        voices_expire
                    })
                    alert(this.props.langText.Message.DataUpdateSuccess);
                    this.reactTableRefresh(true);
                    break;
                case 'delete':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/delete`, {
                        user_id,
                        hm15_id,
                        hm20_id_check,
                        isLoginedUser
                    })
                    alert(this.props.langText.Message.DataDeleteSuccess);
                    this.reactTableRefresh(true);
                    break;
                default:
                    this.showErrorObjectMessage('ModalTypeError');
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        } finally {
            // モーダルを閉じる際に外線番号のエラー状態をリセット
            this.setState({
                show: false,
                external_number_invalids: []
            });
        }
    };

    // キャンセルボタンなどから直接呼び出される閉じる処理（外線番号エラーもリセット）
    modalClose = () => {
        this.resetModalTransientState();
    }

    // Issue #443: 二要素認証の無効化（確認モーダル経由でのみ実行する）
    // target 未指定は親ユーザー、{hm16_id, sub_user_id} を渡すとそのサブユーザーが対象
    openMfaOffModal = (target = null) => {
        this.setState({showMfaOffModal: true, mfaOffTarget: target, mfaOffPassword: ''});
    }

    closeMfaOffModal = () => {
        // パスワードは画面に残さない
        this.setState({showMfaOffModal: false, mfaOffTarget: null, mfaOffPassword: ''});
    }

    executeMfaOff = async () => {
        const target = this.state.mfaOffTarget;
        try {
            this.setState({mfaOffExecuting: true});
            this.blockUI();
            // hm16_id を送らないとサーバは親ユーザーを対象にする。
            // サブユーザーが対象のときは必ず hm16_id を含める
            const params = {
                hm15_id: this.state.hm15_id,
                password: this.state.mfaOffPassword
            };
            if (target && target.hm16_id) {
                params.hm16_id = target.hm16_id;
            }
            await this.ascAxios('post', `${this.reactContainerPath}/updateMfaOff`, params);
            alert(this.props.langText.Message.Mfa_OffConfirmSuccess);
            if (target && target.hm16_id) {
                this.setState({
                    mfa_sub_users: this.state.mfa_sub_users.map(row =>
                        row.hm16_id === target.hm16_id ? {...row, mfa_enabled: false} : row
                    ),
                    showMfaOffModal: false,
                    mfaOffTarget: null,
                    mfaOffPassword: ''
                });
            } else {
                this.setState({
                    mfa_enabled: false,
                    showMfaOffModal: false,
                    mfaOffTarget: null,
                    mfaOffPassword: ''
                });
            }
            this.reactTableRefresh(true);
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err, 'Mfa_OffError');
            // パスワード誤りなど再入力で解決するため、モーダルは開いたままにする
            this.setState({mfaOffPassword: ''});
        } finally {
            this.setState({mfaOffExecuting: false});
            this.unblockUI();
        }
    }

    // モーダル閉鎖時にリセットしたい一時的なstateをここで一元管理
    resetModalTransientState = () => {
        this.setState({
            show: false,
            external_number_invalids: []
        });
    }

    /**
     * サブID 作成上限が保存できる値かどうか（Issue #541）
     *
     * 未設定（キーなし）と null は「既定 5 件へ戻す」意図として通す。
     * それ以外は 1〜100 の整数のみ。サーバー側の validateSubUserLimit と同じ判定で、
     * 範囲外の値でモーダルが閉じて入力が失われるのを防ぐために画面側にも置く。
     */
    validateSubUserLimit = options => {
        if (!options || typeof options !== "object") return true;
        if (!Object.prototype.hasOwnProperty.call(options, "sub_user_limit")) return true;

        const value = options.sub_user_limit;
        if (value === null) return true;
        if (!Number.isInteger(value)) return false;
        return value >= GlobalConst.VALUES.sub_user_limit_min
            && value <= GlobalConst.VALUES.sub_user_limit_max;
    }

    /**
     * 更新時に送る options を組み立てる（Issue #541 レビュー指摘）
     *
     * モーダルの初期値は一覧取得時のキャッシュ行であり、開いている間に他の管理者が
     * sub_user_limit を変更していることがある。利用者が上限を触っていない保存では
     * キーごと落とし、サーバー側のマージ（キー無し＝変更なし）に委ねる。
     * キーを付けたまま送ると、無関係な項目だけの保存で上限が古い値へ巻き戻る。
     *
     * @param {Object} options モーダルの現在値
     * @param {number|null} loaded モーダルを開いた時点の sub_user_limit（未設定は null）
     */
    buildOptionsForUpdate = (options, loaded) => {
        if (!options || typeof options !== "object") return options;
        if (!Object.prototype.hasOwnProperty.call(options, "sub_user_limit")) return options;

        // null と undefined はどちらも「未設定」を指すため、同じ意味なら変更とみなさない
        // （?? はこのビルド構成の babel が解釈できないため使わない）
        const current = (options.sub_user_limit === undefined || options.sub_user_limit === null)
            ? null : options.sub_user_limit;
        const before = (loaded === undefined || loaded === null) ? null : loaded;
        if (current !== before) return options;

        const merged = {...options};
        delete merged.sub_user_limit;
        return merged;
    }

    /**
     * 各画面のボタン押下条件
     */
    validationHandle = param => {
        let validation_flag = false;
        let {
            user_id,
            hm73_id,
            password,
            tel_number,
            mail_address,
            external_number_val,
            isLoginedUser,
            options
        } = this.state;
        // 外線番号については state の external_number_invalids に依存せず都度再計算し、
        // setState 非同期更新タイミングによるレースを排除する。
        const { invalids: recomputedInvalids } = evaluateExternalNumbers(
            Array.isArray(this.state.external_number) ? this.state.external_number : []
        );
        switch (param) {
            case 'insert':
            case 'update':
                validation_flag = !!(user_id && hm73_id&&
                    (password? this.validatePassword(password): true)&&
                    (tel_number? this.validateTelNumber(tel_number): true)&&
                    (mail_address? this.validateMail(mail_address): true)&&
                    (external_number_val && external_number_val.length > 0
                        ? recomputedInvalids.length === 0
                        : true)&&
                    // 【#541】サブID 作成上限が範囲外のままでは保存させない。
                    // サーバー側も 400 InvalidParameter で拒否するが、そこまで進むと
                    // モーダルが閉じて入力が失われるため、保存ボタンの側で止める。
                    this.validateSubUserLimit(options)
                );
                break;
            case 'read':
                validation_flag = !!(user_id);
                break;
            case 'delete':
                validation_flag = !!(user_id && !isLoginedUser);

                break;
            default:
                break;
        }
        return validation_flag;
    };

    /**
     * modalTypeにより分岐させる
     */
    getModalBranch = () => {
        switch (this.state.modalType) {
            case 'insert':
                return (
                    <UserInsertModal
                        state = {this.state}
                        userInfo={this.props.userInfo}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onSelectChange = {this.onSelectChange}
                        onMultiSelectChange = {this.onMultiSelectChange}
                        onMultiSelectChange_External = {this.onMultiSelectChange_External}
                        validationHandle = {this.validationHandle}
                        validateMail = {this.validateMail}
                        validateTelNumber = {this.validateTelNumber}
                    />
                )
            case 'update':
                return (
                    <UserUpdateModal
                        state = {this.state}
                        userInfo={this.props.userInfo}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        onTextChange = {this.onTextChange}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onSelectChange = {this.onSelectChange}
                        onMultiSelectChange = {this.onMultiSelectChange}
                        onMultiSelectChange_External = {this.onMultiSelectChange_External}
                        validateMail = {this.validateMail}
                        validateTelNumber = {this.validateTelNumber}
                        validatePassword = {this.validatePassword}
                        validationHandle = {this.validationHandle}
                        onMfaOff = {this.openMfaOffModal}
                    />
                )
            case 'delete':
                return (
                    <UserDeleteModal
                        state = {this.state}
                        userInfo={this.props.userInfo}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}/>
                )
            case 'read':
                return (
                    <UserReadModal
                        state = {this.state}
                        userInfo={this.props.userInfo}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}/>
                )
            default:
                break
        }
    }

    // CommonTable からの選択変更通知を受けて選択行を保持する。
    // 参照を固定するためクラスフィールド(アロー関数)で定義する。
    // インライン関数で渡すと props.onSelectedDataChange が毎レンダー新しい参照になり、
    // CommonTable 側の useEffect(deps に onSelectedDataChange を含む)が毎レンダー発火して
    // setState ループ(モーダルのテキスト入力不可)を招くため。
    handleSelectedDataChange = (selected) => {
        this.setState({ selectedData: selected });
    };

    render() {
        return (
            <div className='User'>
                {/*一覧画面*/}
                <Row>
                    <Col xs={12} md={12}>
                        <Button
                            id = 'user-insert'
                            className = 'table-button'
                            variant = 'default'
                            size = 'sm'
                            onClick={this.modalShow('insert')}
                            hidden={!this.props.currentPermission.create}
                        >
                            {this.props.langText.Body.InsertTitle}
                        </Button>
                        <Button
                            id = 'user-update'
                            className = 'table-button'
                            variant = 'default'
                            size = 'sm'
                            onClick={this.modalShow('update')}
                            hidden={!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.UpdateTitle}
                        </Button>
                        <Button
                            id = 'user-read'
                            className = 'table-button'
                            variant = 'default'
                            size = 'sm'
                            onClick={this.modalShow('read')}
                            hidden={!!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.ReadTitle}
                        </Button>
                        <Button
                            id = 'user-delete'
                            className = 'table-button'
                            variant = 'default'
                            size = 'sm'
                            onClick={this.modalShow('delete')}
                            hidden={!this.props.currentPermission.delete}
                            disabled={this.state.selectedData.length === 0}
                        >
                            {this.props.langText.Body.DeleteTitle}
                        </Button>
                    </Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            state = {this.state}
                            tableHeight={this.props.tableHeight}
                            tbodyHeight={this.props.tableHeight-30}
                            propsPageIndex = {this.state.pageIndex? this.state.pageIndex: 0}
                            columns={this.state.columns}
                            data={this.state.data}
                            pageSize={this.state.pageSize}
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            sorted={this.state.sorted}
                            pageCount = {this.state.pageCount}
                            manual = {true}
                            showPagination={true}
                            showCheckbox={true}
                            onSelectedDataChange={this.handleSelectedDataChange}
                            showPageSize = {true}
                            showFilter = {true}
                            langText = {this.props.langText.Table}
                        />
                    </Col>
                </Row>
                {/*モーダル表示分岐*/}
                {this.getModalBranch()}
                {/* Issue #443: 二要素認証の無効化確認モーダル */}
                <UserMfaOffModal
                    show = {!!this.state.showMfaOffModal}
                    userId = {this.state.mfaOffTarget
                        ? this.state.mfaOffTarget.sub_user_id
                        : this.state.user_id}
                    password = {this.state.mfaOffPassword}
                    isExecuting = {this.state.mfaOffExecuting}
                    onChangePassword = {value => this.setState({mfaOffPassword: value})}
                    langText = {this.props.langText}
                    onHide = {this.closeMfaOffModal}
                    onExecute = {this.executeMfaOff}
                />
            </div>
        );
    }
}
